module.exports = __webpack_public_path__ + "img/noMsg.3e720ec4.png";